<template>
    <table class="w-full ">
        <thead
            class="text-xl border-t border-b-2 text-output-primary border-output-primary "
        >
            <tr>
                <th
                    v-for="(header, index) in tables.headers"
                    :key="index"
                    class="p-3 "
                >
                    {{ header.title }}
                </th>
            </tr>
        </thead>
        <tbody class="text-lg text-output-primary">
            <template v-for="(tableData, tableIndex) in tables.data">
                <tr :key="tableIndex" class="border-b border-output-primary ">
                    <td
                        class="w-full p-3 font-semibold text-center"
                        colspan="10"
                    >
                        {{ tableData.title }}
                    </td>
                </tr>
                <tr
                    v-for="(cellsContent, cellsIndex) in tableData.content"
                    :key="cellsContent"
                    :class="[
                        'text-center  border-output-primary',
                        {
                            'border-b':
                                tableData.content.length !== cellsIndex + 1,
                            ' border-b-2':
                                tableData.content.length === cellsIndex + 1
                        }
                    ]"
                >
                    <td
                        v-for="(cellData, CellIndex) in cellsContent"
                        :key="CellIndex"
                        class="p-2"
                    >
                        {{ cellContent(cellData, CellIndex) }}
                    </td>
                </tr>
            </template>
        </tbody>
    </table>
</template>

<script>
import { formatPrice } from "@/utils";
export default {
    props: {
        tables: {
            type: Object,
            required: true
        }
    },
    computed: {
        cellContent() {
            return (cellContent, index) => {
                const ContentType = this.tables.headers[index].type;
                if (ContentType !== "String") {
                    switch (ContentType) {
                        case "Currency":
                            return formatPrice(cellContent) + " DH";
                    }
                }
                return cellContent;
            };
        }
    }
};
</script>

<style></style>
